/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { BlogList } from "@modules/study/blog/blog_category";
import { BlogHeroSimple } from "@modules/study/blog/components/blog_hero_simple";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";

const BlogCategory = ({ pageData, latestPost, blog_cat_slug }) => {
  const router = useRouter();
  const { query } = router;
  const [paginate, setPaginate] = useState();
  const [blogItem, setBlogItem] = useState([]);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchhead, setSearchhead] = useState({});
  const category_slug = query.blog_cat_slug;

  useEffect(() => {
    if (query) {
      setPage(parseInt(query.page));
    }
  }, [query]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const categoryBlogApi = `/public/blog-page/category/${category_slug}?limit=5&page=${page}`;
        if (category_slug !== undefined) {
          const resp = await API.get(categoryBlogApi);
          setSearchhead(resp.data.searcHead);
          const { results, total, limit, page_total, currentPage } = resp.data;
          setLoading(false);
          setBlogItem(results);
          setPaginate({ total, limit, page_total, currentPage });
        }
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    if (page && page > 0) {
      fetchData();
    }
  }, [page, category_slug]);

  const handleChange = (pageNum) => {
    setPage(pageNum || 1);
    router.push(
      `/blog/category/${query.blog_cat_slug}/?page=${pageNum}`,
      undefined,
      {
        shallow: true,
      }
    );
    setPage(pageNum);
  };
  return (
    <LayoutMain
      isHeaderSticky={true}
      title={pageData?.searcHead?.title}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/blog/category/${blog_cat_slug}`}
    >
      <BlogHeroSimple forCategory title={searchhead?.title} />
      {category_slug !== undefined && (
        <BlogList
          blogList={blogItem}
          paginate={paginate}
          handlePager={handleChange}
          loadingList={loading}
          error={error}
        />
      )}
    </LayoutMain>
  );
};

export default BlogCategory;
